import { render } from "./pda.vue?vue&type=template&id=27a66616"
import script from "./pda.vue?vue&type=script&lang=js"
export * from "./pda.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__